ValidationEngine = App.loadClass 'core::ValidationEngine'

class exports.AddEditWeightSetDialog extends DialogHandler

    init: () ->
        @layoutUrl = 'backend/portal/weightings/load-add-edit-dialog'
        @saveUrl = 'backend/portal/weightings/save-weight-set'
        @classes = 'small_dialog'

        @refreshNavHandler = false
        @successAction = @updateTaffy

        @createDialog()

        @validator = new ValidationEngine()
        @validator.stopValidating()

    afterLoadLayout: (selector, response) ->
        if response.status?.type isnt 'success'
            @openDialog()
            return

        @validator.registerRule
            'selector': '.validate-unique'
            'text': 'Weight Set Name must be unique'
            'ajax':
                'url': 'backend/portal/weightings/validate-ws-name'
                'data': (elem) =>
                    'ws_name': elem.val()
                    'pp_id': @dialog.find('input[name=pp_id]').val()
                    'ws_id': @dialog.find('input[name=ws_id]').val()
            'func': (data) ->
                return data is 'good'

        @validator.makeFormValidator 'addws', '#frm_addws', '#addws_errors', (valid) =>
            if valid
                # Perform an action if the form successfully validated
                @save('Saving...')
            else
                # Perform an action if the form validation failed

        @dialog.find('.save-btn').bind 'click', () =>
            # ok, now we're ready to validate - go!
            @validator.startValidating()
            @validator.validateForm('addws')

        @openDialog()


    updateTaffy: (response) ->
        ws = response.data

        # update taffy
        if @parent.taffyObjects.ws( id: ws.id ).count()
            @parent.taffyObjects.ws( id: ws.id ).update(ws)
        else
            @parent.taffyObjects.ws.insert(ws)

        @parent.renderWeightSetSelect(ws.id)
        @parent.renderZoneSelects()
